import script from "./SearchPaxMixins.vue?vue&type=script&lang=ts"
export * from "./SearchPaxMixins.vue?vue&type=script&lang=ts"

const __exports__ = script;

export default __exports__